module.exports = __webpack_public_path__ + "img/new-community.d1c843e4.png";